import { createNode } from '@glueapp/graph-types';

export const ParseBasicAuth = createNode({
    id: 'ParseBasicAuth',
    name: 'Parse Basic Auth',
    description: 'Parse a Basic Authentication header into username and password',
    category: 'API Server',
    color: '#808080',
    inPorts: {
        Authorization: { kind: 'string' },
    },
    outPorts: {
        Username: { kind: 'string' },
        Password: { kind: 'string' },
    },
    execute: input => {
        const authorization = input.inPorts.Authorization as string | null;

        if (!authorization || typeof authorization !== 'string') {
            return { output: { Username: '', Password: '' } };
        }

        const trimmed = authorization.trim();
        if (!trimmed.toLowerCase().startsWith('basic ')) {
            return { output: { Username: '', Password: '' } };
        }

        const base64Part = trimmed.slice(6);
        let decoded: string;
        try {
            decoded = atob(base64Part);
        } catch {
            return { output: { Username: '', Password: '' } };
        }

        const colonIndex = decoded.indexOf(':');
        if (colonIndex === -1) {
            return { output: { Username: '', Password: '' } };
        }

        const username = decoded.slice(0, colonIndex);
        const password = decoded.slice(colonIndex + 1);

        return { output: { Username: username, Password: password } };
    },
});
